import { createAsyncThunk } from '@reduxjs/toolkit';
import { CommissionAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  IGetCategoryCommissionHistoryDTO,
  IGetCategoryCommissionHistoryResponse,
  IGetCategoryCommissionsResponse,
  IGetCommissionHistoryFiltersResponse,
  IGetCommissionHistoryListResponse,
  IUpdateCategoryCommissionsDTO,
} from '@/models/commission.model';
import GetCommissionHistoryListDTO from '../dtos/GetCommissionHistoryListDTO';
import { TCommissionHistoryQuery } from '../helpers';
import { COMMISSION_SLICE_NAME } from './models';

export const getCategoryCommissions = createAsyncThunk<
  IGetCategoryCommissionsResponse,
  void,
  { serializedErrorType: IApiError }
>(
  `${COMMISSION_SLICE_NAME}/getCategoryCommissions`,
  async () => {
    const response = await CommissionAPI.getCategoryCommissions();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateCategoryCommissions = createAsyncThunk<
  { data: boolean },
  IUpdateCategoryCommissionsDTO,
  { serializedErrorType: IApiError }
>(
  `${COMMISSION_SLICE_NAME}/updateCategoryCommissions`,
  async (data) => {
    const response = await CommissionAPI.updateCategoryCommissions(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getCategoryCommissionHistory = createAsyncThunk<
  IGetCategoryCommissionHistoryResponse & { categoryId: string },
  IGetCategoryCommissionHistoryDTO,
  { serializedErrorType: IApiError }
>(
  `${COMMISSION_SLICE_NAME}/getCategoryCommissionHistory`,
  async (data) => {
    const response = await CommissionAPI.getCategoryCommissionHistory(data);
    return { ...response.data, categoryId: data.categoryId };
  },
  { serializeError: formatApiError },
);

export const getCommissionHistoryList = createAsyncThunk<
  IGetCommissionHistoryListResponse,
  TCommissionHistoryQuery,
  { serializedErrorType: IApiError }
>(
  `${COMMISSION_SLICE_NAME}/getCommissionHistoryList`,
  async (query) => {
    const response = await CommissionAPI.getCommissionHistoryList(new GetCommissionHistoryListDTO(query));
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getCommissionHistoryFilters = createAsyncThunk<
  IGetCommissionHistoryFiltersResponse,
  void,
  { serializedErrorType: IApiError }
>(
  `${COMMISSION_SLICE_NAME}/getCommissionHistoryFilters`,
  async () => {
    const response = await CommissionAPI.getCommissionHistoryFilters();
    return response.data;
  },
  { serializeError: formatApiError },
);
